import cs from 'classnames';
import { type ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

type P = ComponentProps<typeof RouterLink>;

const Link = ({ children, className, ...rest }: P) => {
  const { t } = useTranslation();

  return (
    <RouterLink className={cs('ui-link', className)} {...rest}>
      {typeof children === 'string' ? t(children) : children}
    </RouterLink>
  );
};

export default Link;
